import QRCode from 'qrcode'
import { useEffect, useState } from 'react'

import { useInvoicePaymentMethods } from '@/api/models/finance'

type Props = {
  invoiceId?: string
  qrContent?: string
}

export const useQRCode = ({ invoiceId, qrContent }: Props) => {
  const { data: paymentMethods } = useInvoicePaymentMethods({ invoiceId })

  const [qrCode, setQrCode] = useState<string | null>(null)

  useEffect(() => {
    if (qrContent) {
      QRCode.toDataURL(qrContent, (_, url) => {
        setQrCode(url)
      })
    }
    if (paymentMethods?.qr) {
      QRCode.toDataURL(paymentMethods?.qr.qrContent, (_, url) => {
        setQrCode(url)
      })
    }
  }, [paymentMethods?.qr])

  return qrCode
}
